import script from "./banner-one.vue?vue&type=script&setup=true&lang=js"
export * from "./banner-one.vue?vue&type=script&setup=true&lang=js"

import "./banner-one.vue?vue&type=style&index=0&id=4ff80519&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff80519"]])

export default __exports__